export default "__VITE_ASSET__e5989da5__"